import axios from "axios";
import {searchDealerEndpoint} from '../../utils/constants/EndPoint';

export async function submitDealerSearch(searchCriteria, appConfig) {
  if (searchCriteria.searchString && searchCriteria.searchString !== '') {
    const headers = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    searchCriteria.searchString = searchCriteria.searchType === 'LOCATION'? searchCriteria.searchString.replace(' ',''): searchCriteria.searchString;
    searchCriteria.customerPostalCode = searchCriteria.customerPostalCode?.replace(' ','');
    const submitUrl = appConfig.exrServiceApi + searchDealerEndpoint;
    const {status, data} = await axios.post(submitUrl, JSON.stringify(searchCriteria), headers);
    if (status === 200){
      return data;
    }
    return undefined;
  }
  return null;
}
